export enum AppInstancesDefaults {
  ProjectsGCTime = 15 * 1000,
  NavigationStaleTime = 20 * 1000,
  BreadcrumbsStaleTime = 20 * 1000,
  LegacyAppLaunchListGCTime = 20 * 1000,
  LogoStaleTime = 30 * 1000,
  HierarchySettingsGCTime = 0,
}
